import React from "react";
import { motion } from "framer-motion";

export const HcaReveal = ({ children, delay = 0, className = "" }) => (
    <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.55, delay }}
        className={className}
    >
        {children}
    </motion.div>
);

export const HcaEyebrow = ({ children }) => (
    <p className="text-[11px] uppercase tracking-[0.22em] font-semibold text-[#D4A140]">{children}</p>
);

export const scrollToForm = () =>
    document.getElementById("hca-form")?.scrollIntoView({ behavior: "smooth", block: "start" });
